import { useEffect } from "react";
import { useLoaderData } from "react-router-dom";

import { useProCliStore } from "../../../../../components/cm/Dashboard/FullPages/ClientDetail/ProvApptDetails/ProviderListv2/hooks/useProCliStore";
import ProviderListv2 from "../../../../../components/cm/Dashboard/FullPages/ClientDetail/ProvApptDetails/ProviderListv2/ProviderListv2";
import Navigation from "../../../../../components/navigations/finance/cases/detail/navigation";
import useParentLoaderData from "../../../../../hooks/useParentLoaderData";

export default () => {
  const { _case } = useParentLoaderData();
  const { providerClientObj, providerClientRecCount } = useLoaderData();
  const { setShouldFetchData, limit, shouldFetchData } = useProCliStore();

  useEffect(() => {
    setShouldFetchData(false);
  }, [limit, shouldFetchData]);

  return (
    <Navigation activeTab="providers" _case={_case}>
      <div className="p-4">
        <ProviderListv2
          caseInfo={_case}
          isDashboardComponent={false}
          providerInfo={providerClientObj}
          count={providerClientRecCount}
        />
      </div>
    </Navigation>
  );
};
